import React from 'react';
import { useTranslation } from 'react-i18next';
import { SparklesIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Vision() {
  const {
    t
  } = useTranslation();
  return <section className="w-full py-32 px-6 bg-gradient-to-b from-white to-slate-50" data-id="element-126">
      <div className="max-w-5xl mx-auto" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-128">
          <div className="inline-flex items-center gap-3 mb-8 glass rounded-full px-6 py-3" data-id="element-129">
            <SparklesIcon className="w-6 h-6 text-teal-600" data-id="element-130" />
            <h2 className="text-5xl md:text-6xl font-bold text-gradient" data-id="element-131">
              {t('vision.title')}
            </h2>
            <SparklesIcon className="w-6 h-6 text-blue-600" data-id="element-132" />
          </div>
          <motion.div whileHover={{
          scale: 1.02
        }} transition={{
          type: 'spring',
          stiffness: 300
        }} className="relative glass rounded-3xl p-12 md:p-16 shadow-2xl overflow-hidden" data-id="element-133">
            <div className="absolute inset-0 bg-gradient-to-br from-teal-500/10 to-blue-500/10" data-id="element-134" />
            <p className="relative text-xl md:text-2xl text-slate-700 leading-relaxed font-light" data-id="element-135">
              {t('vision.text')}
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}